import React from 'react';
import DatePickerContext from '../context/DatePickerContext';
import Sprites from './Sprites';
import { DatePicker, DatePickerWrapper } from './styles/ReactDatepicker.styled';

export default function ReactDatePicker({ type, clicked, delayShowUp, dir }) {
  const [selectedType, setSelectedType] = React.useState(type);
  const { date, setDate } = React.useContext(DatePickerContext);

  const handleClick = () => {
    switch (selectedType) {
      case 'year':
        setSelectedType('month');
        break;
      case 'month':
        setSelectedType('year');
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    const headerEl = document.querySelector('.react-datepicker__header');
    if (headerEl) {
      headerEl.addEventListener('click', handleClick);
      return () => {
        headerEl.removeEventListener('click', handleClick);
      };
    }
    return () => {};
  }, []);
  const types = {
    month: {
      dateFormat: 'MMM yyyy',
      showMonthYearPicker: true,
      showFourColumnMonthYearPicker: true,
      onChange: (_date) => setDate(_date),
    },
    year: {
      dateFormat: 'MMM yyyy',
      showYearPicker: true,
      yearItemNumber: 12,
      shouldCloseOnSelect: false,
      onChange: (_date) => {
        setDate(_date);
      },
    },
  };

  return (
    <DatePickerWrapper clicked={clicked} delayShowUp={delayShowUp} dir={dir}>
      <DatePicker dir={dir} selected={date} {...types[selectedType]} className="datepicker" />
      <Sprites name="calendar" />
    </DatePickerWrapper>
  );
}
